/* Soraya – Chihuahua Winter Coat landing section */
(function () {
  function readJSON(root, sel) {
    var el = root.querySelector(sel);
    try { return JSON.parse(el ? el.textContent : 'null'); } catch (e) { return null; }
  }

  function init(root) {
    if (!root || root.dataset.shInit) return;
    root.dataset.shInit = '1';

    /* gallery */
    var main = root.querySelector('[data-sh-main]');
    var thumbs = root.querySelectorAll('[data-sh-thumb]');
    function showImage(src) {
      if (!src || !main) return;
      main.src = src;
      thumbs.forEach(function (o) { o.classList.toggle('is-active', o.getAttribute('data-src') === src); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showImage(t.getAttribute('data-src')); });
    });

    var variants = readJSON(root, '[data-sh-variants]') || [];
    var colors = readJSON(root, '[data-sh-colors]') || [];
    var sizes = readJSON(root, '[data-sh-sizes]') || [];
    var tiers = root.querySelectorAll('[data-sh-tier]');
    var btn = root.querySelector('[data-sh-atc]');
    var status = root.querySelector('[data-sh-status]');
    var form = root.querySelector('.sh-form');
    var defaultSize = sizes[1] || sizes[0];

    /* one pick per coat: remembered across bundle switches */
    var picks = [];
    function pickAt(i) {
      if (!picks[i]) picks[i] = { color: colors[0] ? colors[0].name : null, size: defaultSize };
      return picks[i];
    }

    function findVariant(bundle, color, size) {
      return variants.filter(function (v) {
        return v.options.indexOf(bundle) > -1 && v.options.indexOf(color) > -1 && v.options.indexOf(size) > -1;
      })[0];
    }

    function renderItems(tier) {
      var box = tier.querySelector('[data-sh-items]');
      if (!box) return;
      var qty = parseInt(tier.getAttribute('data-qty'), 10) || 1;
      var html = '';
      for (var i = 0; i < qty; i++) {
        var p = pickAt(i);
        html += '<div class="sh-item" data-index="' + i + '">' +
          '<span class="sh-item__n">#' + (i + 1) + '</span>' +
          '<div class="sh-dots" role="radiogroup" aria-label="Color for coat ' + (i + 1) + '">' +
          colors.map(function (c) {
            var on = c.name === p.color;
            return '<button type="button" class="sh-dot' + (on ? ' is-on' : '') + '" data-color="' + c.name +
              '" style="--sw:' + c.swatch + '" role="radio" aria-checked="' + on + '" title="' + c.name + '">' +
              '<span class="sr">' + c.name + '</span></button>';
          }).join('') +
          '</div>' +
          '<span class="sh-item__color">' + (p.color || '') + '</span>' +
          '<select class="sh-size" aria-label="Size for coat ' + (i + 1) + '">' +
          sizes.map(function (s) { return '<option' + (s === p.size ? ' selected' : '') + '>' + s + '</option>'; }).join('') +
          '</select>' +
          '</div>';
      }
      box.innerHTML = html;
    }

    function selectedTier() {
      var t = null;
      tiers.forEach(function (x) { var i = x.querySelector('input'); if (i && i.checked) t = x; });
      return t;
    }

    function sync() {
      tiers.forEach(function (t) {
        var on = t === selectedTier();
        t.classList.toggle('is-selected', on);
        var box = t.querySelector('[data-sh-items]');
        if (on) renderItems(t); else if (box) box.innerHTML = '';
      });
      validate();
    }

    function lineItems() {
      var t = selectedTier();
      if (!t) return null;
      var bundle = t.querySelector('input').value;
      var qty = parseInt(t.getAttribute('data-qty'), 10) || 1;
      var items = [];
      for (var i = 0; i < qty; i++) {
        var p = pickAt(i);
        var v = findVariant(bundle, p.color, p.size);
        if (!v || !v.available) return null;
        items.push({ id: v.id, quantity: 1 });
      }
      return items;
    }

    function validate() {
      if (!btn) return;
      var ok = !!lineItems();
      btn.disabled = !ok;
      if (status) status.textContent = ok ? '' : 'One of your picks is sold out, choose another color or size.';
    }

    root.addEventListener('change', function (e) {
      if (e.target.name === 'sh-bundle') sync();
      if (e.target.classList.contains('sh-size')) {
        var row = e.target.closest('.sh-item');
        pickAt(+row.getAttribute('data-index')).size = e.target.value;
        validate();
      }
    });

    root.addEventListener('click', function (e) {
      var dot = e.target.closest('.sh-dot');
      if (!dot) return;
      var row = dot.closest('.sh-item');
      var i = +row.getAttribute('data-index');
      pickAt(i).color = dot.getAttribute('data-color');
      row.querySelectorAll('.sh-dot').forEach(function (d) {
        var on = d === dot;
        d.classList.toggle('is-on', on);
        d.setAttribute('aria-checked', on);
      });
      row.querySelector('.sh-item__color').textContent = pickAt(i).color;
      var c = colors.filter(function (x) { return x.name === pickAt(i).color; })[0];
      if (c) showImage(c.image);
      validate();
    });

    /* add every coat in the bundle as its own cart line */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var items = lineItems();
        if (!items) return;
        btn.disabled = true;
        if (status) status.textContent = 'Adding to cart…';
        var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root_url + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add to cart'); });
          window.location.href = root_url + 'checkout';
        }).catch(function (err) {
          btn.disabled = false;
          if (status) status.textContent = err.message + ' Please try again.';
        });
      });
    }

    sync();

    /* delivery timeline dates */
    var fmtDate = function (d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); };
    root.querySelectorAll('[data-sh-date]').forEach(function (el) {
      var parts = el.getAttribute('data-sh-date').split('-');
      var a = new Date(), b = new Date();
      a.setDate(a.getDate() + parseInt(parts[0], 10));
      b.setDate(b.getDate() + parseInt(parts[1] || parts[0], 10));
      el.textContent = !parts[1] ? fmtDate(a) : fmtDate(a) + ' – ' + fmtDate(b);
    });
  }

  function boot() { document.querySelectorAll('.sh').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
